module.exports = __webpack_public_path__ + "static/media/balmain_3.b260238e.jpg";